// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonCircleAnimated-module_iconContainer__aPDKa {
    background-color: var(--cw-btn-bg);
    border-radius: 20px;
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
}

.buttonCircleAnimated-module_text__liysK {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 16px;
    right: 40px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.2s ease 0s;
}

.buttonCircleAnimated-module_text__liysK.buttonCircleAnimated-module_textVisible__PVBV1 {
    opacity: 1;
    transition: opacity 0.3s ease 0.8s;
}

/* Sync iconContainer background with button hover/active via inherited CSS vars */
@media (hover: hover) and (pointer: fine) {
    button:not(:disabled):hover > .buttonCircleAnimated-module_iconContainer__aPDKa {
        background-color: var(--cw-btn-bg-hover);
    }
}

button:not(:disabled):active > .buttonCircleAnimated-module_iconContainer__aPDKa {
    background-color: var(--cw-btn-bg-active);
}

button:disabled > .buttonCircleAnimated-module_iconContainer__aPDKa {
    background-color: var(--cw-btn-bg-disabled);
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Buttons/styles/buttonCircleAnimated.module.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,kCAAkC;AACtC;;AAEA,kFAAkF;AAClF;IACI;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2CAA2C;AAC/C","sourcesContent":[".iconContainer {\n    background-color: var(--cw-btn-bg);\n    border-radius: 20px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s;\n}\n\n.text {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 16px;\n    right: 40px;\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    overflow: hidden;\n    opacity: 0;\n    transition: opacity 0.2s ease 0s;\n}\n\n.text.textVisible {\n    opacity: 1;\n    transition: opacity 0.3s ease 0.8s;\n}\n\n/* Sync iconContainer background with button hover/active via inherited CSS vars */\n@media (hover: hover) and (pointer: fine) {\n    :global(button):not(:disabled):hover > .iconContainer {\n        background-color: var(--cw-btn-bg-hover);\n    }\n}\n\n:global(button):not(:disabled):active > .iconContainer {\n    background-color: var(--cw-btn-bg-active);\n}\n\n:global(button):disabled > .iconContainer {\n    background-color: var(--cw-btn-bg-disabled);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContainer": `buttonCircleAnimated-module_iconContainer__aPDKa`,
	"text": `buttonCircleAnimated-module_text__liysK`,
	"textVisible": `buttonCircleAnimated-module_textVisible__PVBV1`
};
export default ___CSS_LOADER_EXPORT___;
